import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CompanyDepartmentService } from '../company-department.service';

export const useGetCompanyDepartments = (
	params?: CompanyDepartments.GetCompanyDepartmentsParams,
	options?: Omit<
		UseQueryOptions<CompanyDepartments.PaginatedCompanyDepartments, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: [
			'company-departments',
			params?.page ?? 1,
			params?.limit ?? 20,
			params?.company_id ?? 'all',
		],
		queryFn: () => CompanyDepartmentService.getAll(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetCompanyDepartment = (
	id: string,
	options?: Omit<
		UseQueryOptions<CompanyDepartments.CompanyDepartment, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	const isEnabled = !!id && (options?.enabled ?? true);
	return useQuery({
		queryKey: ['company-department', id],
		queryFn: () => CompanyDepartmentService.getById(id),
		enabled: isEnabled,
		refetchOnWindowFocus: false,
		...options,
	});
};
